import React from "react";

function MapIcon({ fill }) {
    return (
        <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_549_7850)">
                <path
                    d="M27.4412 21.0335C27.0156 20.7998 26.4813 20.9552 26.2477 21.3806C26.0139 21.8061 26.1693 22.3404 26.5948 22.5741C27.6417 23.1493 28.2422 23.7869 28.2422 24.3235C28.2422 24.9798 27.3123 25.997 24.7024 26.8837C22.1239 27.7598 18.6782 28.2422 15 28.2422C11.3218 28.2422 7.87605 27.7598 5.29764 26.8837C2.6877 25.997 1.75781 24.9798 1.75781 24.3235C1.75781 23.7869 2.35828 23.1493 3.40523 22.574C3.83068 22.3404 3.98607 21.806 3.75234 21.3805C3.51861 20.9552 2.98441 20.7997 2.55885 21.0334C1.39154 21.6747 0 22.7661 0 24.3235C0 25.5173 0.821016 27.2193 4.73215 28.5481C7.48793 29.4844 11.1345 30 15 30C18.8655 30 22.5121 29.4844 25.2679 28.5481C29.179 27.2193 30 25.5173 30 24.3235C30 22.7661 28.6085 21.6747 27.4412 21.0335Z"
                    fill={fill || "#D1D5DB"}
                />
                <path
                    d="M8.3644 25.6131C10.1486 26.1171 12.5052 26.3947 15 26.3947C17.4949 26.3947 19.8515 26.1172 21.6356 25.6131C23.8184 24.9965 24.9252 24.1039 24.9252 22.9602C24.9252 21.8166 23.8184 20.9241 21.6356 20.3075C21.1511 20.1706 20.6241 20.0505 20.0638 19.9481C19.7595 20.4738 19.4407 21.0149 19.1074 21.5716C19.7275 21.6647 20.3098 21.7788 20.8385 21.9135C22.4449 22.3226 23.0318 22.7832 23.1525 22.9603C23.0318 23.1374 22.445 23.598 20.8386 24.0071C19.3181 24.3944 17.3619 24.6153 15.3016 24.635C15.2018 24.6424 15.1013 24.6466 15 24.6466C14.8987 24.6466 14.7982 24.6424 14.6984 24.635C12.6381 24.6153 10.6818 24.3944 9.16139 24.0071C7.55499 23.598 6.96817 23.1374 6.84752 22.9603C6.96817 22.7832 7.55504 22.3226 9.16145 21.9135C9.6902 21.7788 10.2724 21.6647 10.8927 21.5716C10.5593 21.015 10.2405 20.4738 9.93623 19.9481C9.37596 20.0506 8.84891 20.1706 8.3644 20.3075C6.18161 20.9241 5.07483 21.8166 5.07483 22.9602C5.07483 24.1039 6.18161 24.9964 8.3644 25.6131Z"
                    fill={fill || "#D1D5DB"}
                />
                <path
                    d="M15 22.8887C15.7824 22.8887 16.4931 22.49 16.9013 21.8222C19.7612 17.1431 23.1703 10.9764 23.1703 8.17025C23.1703 3.66516 19.5052 0 15 0C10.4949 0 6.82971 3.66516 6.82971 8.17025C6.82971 10.9764 10.2389 17.1431 13.0988 21.8222C13.5069 22.49 14.2177 22.8887 15 22.8887ZM11.716 7.60928C11.716 5.79856 13.1892 4.32539 15 4.32539C16.8108 4.32539 18.284 5.79856 18.284 7.60928C18.284 9.42006 16.8108 10.8932 15 10.8932C13.1892 10.8932 11.716 9.42012 11.716 7.60928Z"
                    fill={fill || "#D1D5DB"}
                />
            </g>
            <defs>
                <clipPath id="clip0_549_7850">
                    <rect
                        width="30"
                        height="30"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MapIcon;
